var LineHeight = {
  normal: 'normal',
  loose: 'loose',
  tight: 'tight'
};
var FontWeight = {
  light: 'light',
  regular: 'regular',
  medium: 'medium',
  bold: 'bold'
};
var FontSize = {
  xs: 'xs',
  s: 's',
  m: 'm',
  l: 'l',
  xl: 'xl'
};
export { FontSize, FontWeight, LineHeight };